<template>
    <UApp :toaster="{ position: 'top-right' }">
        <NuxtLoadingIndicator />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
        <ModalsContainer />
    </UApp>
</template>

<script setup lang="ts">
import { ModalsContainer } from 'vue-final-modal'
import { useGlobalData } from '~/features/useGlobalData'
import { useUserStore } from '~/store/useUserStore'

const { isAuthenticated } = useUserStore()
const { syncGlobalData } = useGlobalData()

if (unref(isAuthenticated)) {
    await syncGlobalData()
}

</script>
